// Public UI adapted from Klargo-Reference/components/ui/input.tsx.
import * as React from "react";
import { cn } from "../../lib/utils.jsx";
const Input = React.forwardRef(({ className, type, ...props }, ref) => {
    // `.ds-input` (public.source.css §31) instead of shadcn's own border/
    // radius/focus utility classes — those are plain Tailwind *utilities*,
    // which in Tailwind's cascade-layer order always beat the DS's own
    // "§30 Focus: white contour + green halo" rule (an @layer components
    // rule keyed off `.ds-scope *:focus-visible` / `.ds-form *:focus-visible`),
    // regardless of specificity or source order. That's why this was the one
    // input in the app with a different focus ring, colour AND radius: its
    // own `rounded-md` and `focus-visible:outline-none` utilities were
    // silently winning over the shared focus treatment every other field in
    // the app gets for free by using `.ds-input` and nothing else.
    return (<input type={type} className={cn("ds-input", className)} ref={ref} {...props}/>);
});
Input.displayName = "Input";
export { Input };
